import React from "react";
import StartStep from "../../components/StartStep/StartStep";
import GreyCard from '../../components/GreyCard/GreyCard'
import MyCard from "../../components/MyCard/MyCard";
import {Accordion, Button, Col, ProgressBar} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

const AboutUs = () => {
    return (
        <div>
            <StartStep>
                <h1>Медицинский осмотр</h1>
            </StartStep>

            <GreyCard>
                <h2>Предварительный медицинский осмотр </h2>
                <p>
                    проходят один раз при первичном найме на работу в НИУ ВШЭ (перезаключение действующих контрактов не
                    является первичным наймом на работу - если Вы работаете в НИУ ВШЭ и подаете документы на конкурс
                    ППС, проходить внеплановый медицинский осмотр не нужно).
                    <br/><br/>
                    Медицинское освидетельствование иностранных граждан <a
                    href="https://www.hse.ru/mirror/pubs/share/582615558.pdf">Порядок МО для иностранных граждан</a>
                </p>
            </GreyCard>

            <br/><br/>

            <MyCard>
                <h2>Пройти предварительный медицинский осмотр возможно:</h2>
                <br/>
                <ul>
                    <li>на территории НИУ ВШЭ - <a href="https://bpm.hse.ru/Runtime/Runtime/Form/EMED__f__Request2/">ЗАПИСЬ
                        через ЕЛК</a></li>
                    <li>в клинике, г. Москва, Земляной вал, 34А, стр.1 (м. Чкаловская, Курская, тел. <a
                        href="tel:+74991100266;">+7-499-110-02-66</a>), <a
                        href="https://goo.gl/maps/C9j6zYFrdRekeX3Y8">карта</a></li>
                </ul>
                <p>
                    Часы приёма специалистов: в рабочие дни (пн-пт) 09:00-17:00, в субботу 08:00-15:00
                    <br/>
                    Выдача выписок из медкарты и заключений: пн-пт 13:00-17:00, сб 09:00-14:00
                    <br/>
                    Сроки готовности выписки можно уточнить по телефону <a href="tel:+74991100266;">+7-499-110-02-66</a>
                </p>
            </MyCard>

            <br/><br/>

            <GreyCard>
                <h2>Обязательна предварительная запись любым из трех способов:</h2>
                <br/>
                <ul>
                    <li>по телефону <a href="tel:+74991100266;">+7-499-110-02-66</a> (пн-пт с 09.00 до 18.00)</li>
                    <li>на сайте записи по <a href="https://mprofiko.ru/">ссылке</a> (круглосуточно) выбрать адрес
                        "Курская" (сотрудники ВШЭ проходят осмотр только по этому адресу) → выбрать вид медосмотра
                        (периодический или предварительный) → выбрать дату и время
                    </li>
                    <li>на сайте записи по <a
                        href="https://pre-reg.mprofiko.legko-mis.ru/online/client_record/1/">ссылке</a> (круглосуточно)
                        выбрать адрес "Курская" (сотрудники ВШЭ проходят осмотр только по этому адресу) → выбрать вид
                        медосмотра (периодический или предварительный) → выбрать дату и время
                    </li>
                </ul>
            </GreyCard>

            <br/><br/>

            <MyCard>
                <h2>
                    Пройти обязательное психиатрическое освидетельствование возможно:
                </h2>
                <br/>
                <p>
                    в клинике, г. Москва, Земляной вал, 34А, стр.1 (м. Чкаловская, Курская, тел. 8-499-110-0266)
                    <br/>
                    Часы приёма специалистов: в рабочие дни (пн-пт) 08:00-19:00
                </p>
                <p>Обязательна <b>предварительная запись</b>:</p>
                <p>
                    - по телефону <a href="tel:+74991100266;">+7-499-110-02-66</a> (пн-пт с 08:00 до 19:00)
                    - на сайте записи по <a
                    href="https://pre-reg.mprofiko.legko-mis.ru/online/client_record/1/">ссылке</a> ссылке
                    (круглосуточно) выбрать адрес "Курская" (сотрудники ВШЭ проходят осмотр только по этому адресу) →
                    открыть вкладку "освидетельствования" → выбрать обязательное психиатрическое освидетельствование →
                    выбрать дату и время
                </p>
                <hr/>
                <p><b>Важно!</b> Для прохождения обязательного психиатрического освидетельствования в клинике
                    потребуется предъявить направление, выданное в Единой приемной</p>
            </MyCard>

            <br/>

            <Container>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header><h2>Направление на медицинский осмотр </h2></Accordion.Header>
                        <Accordion.Body>
                            <p>
                                Выдача направлений на предварительный/периодический медицинский осмотр осуществляется в Единой приемной в часы работы по адресам:
                            </p>
                            <ul>
                                <li>Мясницкая ул., д. 20, М20-122;</li>
                                <li>Покровский б-р, д. 11, М120.</li>
                            </ul>
                            <br/>
                            <p>Для получения направления на медицинский осмотр требуется сформировать запрос с корпоративной электронной почты (при отсутствии электронной почты запрос формирует менеджер подразделения) с указанием следующей информации работника, принимаемого на работу:</p>
                            <ul>
                                <li>Фамилия, имя, отчество;</li>
                                <li>Дата рождения;</li>
                                <li>Номер полиса ОМС (при наличии);</li>
                                <li>Наименование структурного подразделения;</li>
                                <li>Должность.</li>
                            </ul>
                            <br/>
                            <p>Запрос направить на почту <a href="mailto:osh@hse.ru">osh@hse.ru</a></p>
                            <br/>
                            <p>После получения направления требуется сделать соответствующую отметку в Листе получения направления. Лист сдать в Единую приемную.</p>
                            <br/>
                            <p><a href="https://www.hse.ru/mirror/pubs/share/506270806.docx">Лист получения направления </a></p>
                                <p><a href="https://www.hse.ru/medical/medosmotr">Предварительные и периодические медицинские осмотры</a></p>
                                <p><a href="https://benefits.hse.ru/opo">Обязательное психиатрическое освидетельствование</a></p>
                                <p><a href="http://www.hse.ru/medical/p">Порядок предоставления медуслуг, условия софинансирования</a></p>
                                <p><a href="https://www.hse.ru/medical/dms2023">Программа медицинского обслуживания в 2023 году</a></p>
                                <p><a href="http://www.hse.ru/medical/sem">Медицинское обслуживание членов семьи</a></p>
                                <p><a href="https://www.hse.ru/medical/prohealth/">PRO здоровье (полезная информация о здоровом образе жизни)</a></p>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Container>

            <br/><br/>
            <hr/>

            <MyCard>
                <p>
                    В случае возникновения вопросов об обязательных медосмотрах обратиться:
                    в Управление социальной сферы по адресу  <a href="http://social@hse.ru/">social@hse.ru</a>&nbsp;
                    менеджеру программы <a href="https://www.hse.ru/org/persons/563386700">Сатиной Владе Алексеевне</a>: + 7 (495) 772 95 90, доб. 15-503; vsatina@hse.ru
                </p>
                <br/>
                <p><a href="https://www.hse.ru/org/hse/aup/social">Управление социальной сферы</a></p>
            </MyCard>

            <br/><br/>

            <Container>
                <Row className="justify-content-md-center">
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step1">Назад</Button>{' '}
                    </Col>
                    <Col md={1}></Col>
                    <Col md={6} style={{ textAlign: "center", paddingTop: "6px"}}>
                        <ProgressBar now={18}/>
                        <span>Шаг 2 из 11</span>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step3">Вперед</Button>{' '}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AboutUs;